import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  scrollTo?: string;
}
export function CTAButton({
  children,
  className = '',
  scrollTo
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // Fire Meta Pixel AddToCart before navigating to Shopify
      const fbq = (window as any).fbq;
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_name: 'Voices of Freedom Ebook Bundle',
          content_type: 'product',
          value: 17.0,
          currency: 'USD'
        });
      }
    }
  };
  return <motion.a href={scrollTo ? `#${scrollTo}` : 'https://rutinasimple.com//cart/52052374356249:1'} target={scrollTo ? undefined : '_blank'} rel={scrollTo ? undefined : 'noopener noreferrer'} onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        inline-block w-full sm:w-auto text-center
        bg-brand-red text-white font-oswald font-bold text-xl sm:text-2xl
        py-4 px-8 rounded-sm shadow-[0_0_20px_rgba(196,30,58,0.5)]
        border-2 border-brand-gold/50 hover:border-brand-gold
        transition-colors duration-300 animate-pulse-slow
        ${className}
      `} data-id="element-27">
      {children}
    </motion.a>;
}